// Units (DRAW_PLAN G9): everything is stored in points (1/72 in); pixels convert at the document's DPI.
import type { Unit } from './types';

const PER_INCH: Record<Exclude<Unit, 'px'>, number> = { pt: 72, in: 1, mm: 25.4, cm: 2.54 };

/** Value in `unit` → points. Pixels use `dpi` (72 for screen documents, so 1 px = 1 pt). */
export function toPt(v: number, unit: Unit, dpi = 72): number {
  return unit === 'px' ? (v * 72) / dpi : (v / PER_INCH[unit]) * 72;
}
/** Points → value in `unit`. */
export function fromPt(pt: number, unit: Unit, dpi = 72): number {
  return unit === 'px' ? (pt * dpi) / 72 : (pt / 72) * PER_INCH[unit];
}
/** A short display string ("8.5 in", "210 mm"). */
export function formatLength(pt: number, unit: Unit, dpi = 72, digits = 2): string {
  const v = fromPt(pt, unit, dpi);
  return `${Number(v.toFixed(digits))} ${unit}`;
}
